import React from 'react'
import styled from 'styled-components';
import {maxWidth} from '../common/StyleValue'
import Listitem from './Listitems'

const HowStyle = styled.div`
  width: ${maxWidth}px;
  margin: 100px auto 40px;
  .head-tit {
    color: #666;
    text-align: center;
    /* padding-top: 10px; */
    font-size: 22px;
  }
  .title {
    h3 {
      color: #333333;
      text-align: center;
      padding: 10px 0 20px;
    }
  }
  .box-list {
    display: flex;
    justify-content: space-around;
  }
  @media (max-width: 768px) {
    width: calc(100% - 40px);
    margin: 40px 20px 40px;
    .head-tit {
      font-size: 18px;
    }
    .box-list {
      display: block;
    }
  }
`;

export default function HowtoBox() {
  const listData = [
    {
      title: 'For events & creation works',
      number: '01',
      list: [
        'Choose the events or artworks you love to support.',
        'Get TRIAS from exchanges.',
        'Stake TRIAS to support a specific grant.',
        'Wait for the grant to end.',
        'If the grant is fulfilled, TRIAS goes to the initiator. Grant updates will be released accordingly, and sometimes you will receive certain rewards.',
        'If the grant is failed, you will receive your staked TRIAS token.',
      ]
    },
    {
      title: 'For blockchain projects',
      number: '02',
      list: [
        'Choose the projects you love to support.',
        'Get TRIAS from exchanges.',
        'Stake TRIAS to support the specific grant.',
        'Wait for the grant to end.',
        'If the grant is fulfilled, TRIAS goes to the initiator. According to a certain proportion, you will receive the new token issued by the project (1: x).',
        'Grant updates will be released accordingly, and sometimes rewards will be given to the contributors.',
        'If the grant is failed, you will get your staked TRIAS token back.',
      ]
    },
    {
      title: 'For DAO Governance',
      number: '03',
      list: [
        'Choose the proposals you want to support.',
        'Get TRIAS from exchanges.',
        'Stake TRIAS to support the specific grant.',
        'Wait for the grant to end.',
      ]
    },
  ];

  return (
    <HowStyle>
      <div className="head-tit">Support the amazing project that you love.</div>
      <div className="title">
        <h3 className="h3">How to participate in Trias Grant?</h3>
      </div>
      <div className="box-list">
        {listData.map(item=><Listitem key={item.number} {...item}></Listitem>)}
      </div>
    </HowStyle>
  )
}
